CTAMap.view = {
  html: {
    showMore: null,
  },
  resizeTimeout: null,
};

CTAMap.view.ini = function () {
  jQuery('.search-form h2 svg').hide();

  jQuery('.show-more').on('click', function (e) {
    e.preventDefault();
    CTAMap.api.nextPage();
    CTAMap.view.printResults(false, true);
  });

  //more filters
  jQuery('.location-form .advanced').hide();
  jQuery('.location-form .more-filters').click(function () {
    jQuery(this).toggleClass('expanded');
    jQuery('.location-form .advanced').slideToggle({
      complete: function () {
        jQuery(document).trigger('LazyLoad:handle');
      },
    });
    jQuery(this).find('svg').toggleClass('up');
    jQuery(this).find('svg').toggleClass('down');
  });

  jQuery('.location-form .reset-filters').click(function () {
    jQuery(
      'input[name=bicycle-for]:first, input[name=length]:first, input[name=bicycle-type]:first, input[name=terrain]:first'
    )
      .prev('label')
      .click();
    jQuery('input[name=keyword]').val('').trigger('change');
  });

  //radio boxes
  jQuery('label.radio-label').click(function () {
    var t = jQuery(this);
    t.siblings('label.radio-label').removeClass('selected');
    t.addClass('selected');
  });

  //init radio boxes
  jQuery('input[type=radio]:checked').each(function () {
    var id = jQuery(this).attr('id');
    jQuery('label.radio-label[for=' + id + ']').addClass('selected');
  });

  jQuery(window).on('resize', CTAMap.view.disableSearchOnResize);
};

CTAMap.view.disableSearchOnResize = function () {
  CTAMap.queue.disabled = true;
  if (CTAMap.view.resizeTimeout) {
    clearTimeout(CTAMap.view.resizeTimeout);
  }
  CTAMap.view.resizeTimeout = setTimeout(function () {
    CTAMap.queue.disabled = false;
  }, 200);
};

CTAMap.view.getResultsSection = function () {
  return jQuery('.search-result');
};

CTAMap.view.getResults = function () {
  return CTAMap.view.getResultsSection().find('.post-cycling-trip');
};

CTAMap.view.setFilter = function (args) {
  if (typeof args.length !== 'undefined') {
    var radioLid = jQuery('input[name=length][value=' + args.length + ']').attr(
      'id'
    );
    jQuery('label[for=' + radioLid + ']').click();
    jQuery('label[for=' + radioLid + ']').change();
  }

  if (typeof args.difficulty !== 'undefined') {
    var radioRDid = jQuery(
      'input[name=bicycle-for][value=' + args.difficulty + ']'
    ).attr('id');
    jQuery('label[for=' + radioRDid + ']').click();
    jQuery('label[for=' + radioRDid + ']').change();
  }

  if (typeof args.route_type !== 'undefined') {
    var radioRTid = jQuery(
      'input[name=bicycle-type][value=' + args.route_type + ']'
    ).attr('id');
    jQuery('label[for=' + radioRTid + ']').click();
    jQuery('label[for=' + radioRTid + ']').change();
  }

  if (typeof args.terrain !== 'undefined') {
    var radioTid = jQuery(
      'input[name=terrain][value=' + args.terrain + ']'
    ).attr('id');
    jQuery('label[for=' + radioTid + ']').click();
    jQuery('label[for=' + radioTid + ']').change();
  }

  if (typeof args.keywords !== 'undefined') {
    jQuery('.location-search-keyword').val(args.keywords);
    jQuery('.location-search-keyword').trigger('change');
  }
};

CTAMap.view.collapseSearchForm = function () {
  if (jQuery('html').hasClass('prevent-scroll')) {
    return;
  }

  jQuery('html, body').animate(
    {
      scrollTop: jQuery('.search-result').offset().top,
    },
    600
  );
};

CTAMap.view.showShowMore = function () {
  CTAMap.view.getResultsSection().find('.show-more').show();
};

CTAMap.view.hideShowMore = function () {
  CTAMap.view.getResultsSection().find('.show-more').hide();
};

CTAMap.view.showLoading = function () {
  jQuery('.trips-sidebar').addClass('loading-after');
  jQuery('main > section.search-form .location-search-submit').addClass(
    'loading'
  );
};

CTAMap.view.hideLoading = function () {
  jQuery('.trips-sidebar').removeClass('loading-after');
  jQuery('main > section.search-form .location-search-submit').removeClass(
    'loading'
  );
};

CTAMap.view.showResultsSection = function () {
  jQuery('.search-result').show();
};

CTAMap.view.updateCount = function () {
  var countNode = jQuery('.search-result .count');
  var text = window.ys.cycling_trips.count.split('%s');
  var count = jQuery('.search-result article').length;
  var total = CTAMap.api.result.count;
  countNode.html(text[0] + '1 - ' + count + text[1] + total + text[2]);
};

CTAMap.view.removeCount = function () {
  var countNode = jQuery('.search-result .count');
  countNode.html('');
};

CTAMap.view.numberOfAppliedFilters = function () {
  var activeFilters = {};
  jQuery(
    'input[name=bicycle-for], input[name=length], input[name=bicycle-type], input[name=terrain], input[name=keyword]'
  ).change(function () {
    var key = jQuery(this).attr('name');
    if (jQuery(this).val() !== '0' && jQuery(this).val() !== '') {
      activeFilters[key] = true;
    } else {
      activeFilters[key] = false;
    }
    CTAMap.view.setNumberOfAppliedFilters(activeFilters);
  });
};

CTAMap.view.setNumberOfAppliedFilters = function (activeFilters) {
  var counterNode = jQuery('.more-filters .more-filters-number');
  var resetNode = jQuery('.more-filters').nextAll('.reset-filters');
  var count = 0;

  //count them
  for (var filter in activeFilters) {
    if (activeFilters[filter]) {
      count++;
    }
  }

  if (count > 0) {
    counterNode.html('(' + count + ')');
    resetNode.css('visibility', 'visible');
  } else {
    counterNode.html('');
    resetNode.css('visibility', 'hidden');
  }
};

CTAMap.view.printSingleResult = function (data) {
  var section = CTAMap.view.getResultsSection().find('.results');
  var html = jQuery(data.html);

  html.find('article.cycling_trips').on('mouseenter', function () {
    CTAMap.map.markerHighlight.start(data.post.ID);
  });

  html.find('article.cycling_trips').on('mouseleave', function () {
    CTAMap.map.markerHighlight.stop();
  });

  section.append(html);
  CTAMap.map.addMarkerHtml(data.post.ID, data.html);
};

CTAMap.view.removeResults = function () {
  CTAMap.view.getResultsSection().find('.results').empty();
  //CTAMap.map.removeAllElements();
};

CTAMap.view.printResults = function (setCoordinates, append) {
  CTAMap.view.hideShowMore();
  CTAMap.api.setUrl();
  Cookies.set('cycling_trips_last_archive_url', window.location.href);
  if (setCoordinates) {
    GLSearch.setCoordinates(CTAMap.api.args.lat, CTAMap.api.args.lng);
  }

  if (CTAMap.api.xhr) {
    CTAMap.api.xhr.abort();
  }
  CTAMap.api.xhr = CTAMap.api.getResults();

  CTAMap.view.showLoading();

  CTAMap.api.xhr.done(function (data) {
    CTAMap.view.showResultsSection();

    if (!append) {
      CTAMap.view.removeResults();
    }

    CTAMap.api.result = data;
    CTAMap.map.fitBoundsAfterSearch(data);
    CTAMap.api.setArgsFromResult();

    //print html results
    var ids = [];
    var recommended = [];
    for (var i = 0; i < data.results.length; i++) {
      ids.push(data.results[i].post.ID);
      if (data.results[i].route.is_recommended) {
        recommended.push(data.results[i].post.ID);
      }
      CTAMap.view.printSingleResult(data.results[i]);
    }
    jQuery(document).trigger('LazyLoad:reload');

    //count
    CTAMap.view.updateCount();

    // Print markers, store returned quadrants
    for (var quadrant in data.quadrants) {
      if (
        !data.quadrants.hasOwnProperty(quadrant) ||
        !data.quadrants[quadrant].markers
      ) {
        continue;
      }

      CTAMap.map.loadedQuadrants.push(quadrant);
      var markers = data.quadrants[quadrant].markers;

      for (var marker in markers) {
        if (!markers.hasOwnProperty(marker)) {
          continue;
        }
        var isRecommended = recommended.includes(parseInt(marker));
        CTAMap.map.addMarker(
          markers[marker],
          isRecommended ? 'bike_recommended' : 'bike'
        );
      }
    }

    CTAMap.map.doFilterIds(data.filter_ids);

    //dont clear bouncing efect if not first page
    if (!CTAMap.api.args.page || CTAMap.api.args.page === 1) {
      CTAMap.map.markerHighlight.clear();
    }
    CTAMap.map.markerHighlight.ini(ids);

    //if there is selected trip that is not in results, add it to the map but not to the results
    if (
      CTAMap.map.selectedTrip &&
      typeof CTAMap.map.trips[CTAMap.map.selectedTrip.id] === 'undefined'
    ) {
      CTAMap.map.addTrip(CTAMap.map.selectedTrip);
    }

    jQuery(document).trigger('CyclingTrips:updateMapPosition');

    if (data.next) {
      CTAMap.view.showShowMore();
    }
    CTAMap.map.recalculateClusters();
    CTAMap.view.collapseSearchForm();
  });

  CTAMap.api.xhr.fail(function (xhr) {
    CTAMap.view.removeResults();
    if (
      !CTAMap.api.firstRequest &&
      typeof WLCPopup === 'function' &&
      xhr.responseJSON &&
      xhr.responseJSON.data &&
      xhr.responseJSON.data.user_message &&
      CTAMap.api.requestType !== 'map'
    ) {
      var icon = xhr.responseJSON.data.icon ? xhr.responseJSON.data.icon : null;
      var popup = new WLCPopup(xhr.responseJSON.data.user_message, icon);
      popup.show();
    } else {
      console.log(xhr);
    }
    CTAMap.view.removeCount();
  });

  CTAMap.api.xhr.always(function (data) {
    CTAMap.view.hideLoading();
    CTAMap.api.firstRequest = false;
  });
};
